import { CurrentIdentitySchema } from '@repo/auth/contracts';

import type { TemplateBuilderIdentity } from '@/lib/config/template-builder-config';

import { backendRequest } from '@/api/http-client';

/** Resolves and validates the identity associated with the current backend session. */
export async function getCurrentIdentity(): Promise<TemplateBuilderIdentity> {
  const response = await backendRequest<unknown>('/v1/auth/me', 'Failed to resolve identity');
  return CurrentIdentitySchema.parse(response);
}
